import React, { ReactElement, useRef, useState } from 'react';
import getConfig from 'next/config';
import { useRouter } from 'next/router';

import { addHotelPageFiltersToUrl, browserQueryParamFor } from '@/lib/utils/queryParamFilterConversions';

import { ImageGallery } from './ImageGallery';
import { OfferAndFilters } from '@/interfaces';

import gallery from '@/static/icons/gallery.svg';
import noImage from '@/static/icons/noImage.svg';

const {
    publicRuntimeConfig: { imgPath },
} = getConfig();

const renderImage = (supplier: string, imagePaths: string[]): ReactElement => {
    if (imagePaths?.length && supplier.toLocaleLowerCase() !== 'test') {
        const imageFullPath = `${imgPath}480x360c${imagePaths[0]}`;
        return <img src={imageFullPath} className="image-frame center-cropped" alt={supplier} data-testid="resultImage" />;
    } else {
        return <img src={noImage.src} alt={supplier} className="image-frame u-bg-ice center-cropped noImage" data-testid="resultImage" />;
    }
};

export const ImageObject: React.FC<OfferAndFilters> = ({
    offer: { hotelId, imagePaths, supplier },
    filters,
}): ReactElement<OfferAndFilters> => {
    const router = useRouter();
    const [isOpen, setIsOpen] = useState(false);
    const imageRef = useRef<HTMLDivElement | null>(null);
    const hotelPageUrl = addHotelPageFiltersToUrl(`${router.basePath}/hotell?${browserQueryParamFor('hotelId', hotelId)}`, filters);
    const hasImages = Boolean(imagePaths?.length);

    return (
        <>
            <a href={hotelPageUrl} rel="nofollow" data-testid="hotel-image-link">
                {renderImage(supplier, imagePaths)}
            </a>
            <div className="icon--gallery u-hide-lt480 overlay__item_10">
                <button
                    data-testid="galleryButton"
                    aria-label="Åpne bildegalleri"
                    className={`button button--flat button--has-icon ${hasImages ? '' : `button-noImage`}`}
                    onClick={(): void => {
                        setIsOpen(!isOpen);
                        return;
                    }}>
                    {hasImages && isOpen ? (
                        <ImageGallery
                            hotelId={hotelId}
                            imagePaths={imagePaths}
                            data-testid="imageGallery"
                            openGallery={isOpen}
                            imageRef={imageRef}
                            galleryValue={0}
                        />
                    ) : null}
                    {hasImages && supplier.toLocaleLowerCase() !== 'test' ? (
                        <img src={gallery.src} height={gallery.height} width={gallery.width} loading={'lazy'} alt="" />
                    ) : null}
                </button>
            </div>
        </>
    );
};
